import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import { PermissionContext } from "appContext";
import { pages } from "views/pages/manage/common/constant";
import { RolePermissions } from "appContext";
import { ReactComponent as DocumentIcon } from "assets/img/svg/Document.svg";

import DownloadReports from "../../../masters/studentFinancials/paymentCollection/DownloadReports";
import { getCookie } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const commonIconStyles = {
  width: "48px",
  height: "48px",
  borderRadius: "6px",
  backgroundColor: "#EEE",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const CentralizedAdmissionCards = () => {
  const history = useHistory();

  const regularChargesPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["centralizedRegularCharges"]?.["id"]
    );

  const otherChargesPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["centralizedOtherCharges"]?.["id"]
    );

  const paymentCollectionPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["centralizedPaymentCollection"]?.["id"]
    );

  const manageReceiptsPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["centralizedManageReceipts"]?.["id"]
    );

  const dcrPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["centralizedDcr"]?.["id"]
    );

  const [isOpenReportDialog, setIsOpenReportDialog] = useState(false);

  const cards = [
    regularChargesPermissions && {
      heading: "Apply Centralized Charges",
      subHeading:
        "Counselors can apply charges for students from other branches.",
      icon: (
        <div style={commonIconStyles}>
          <DocumentIcon />
        </div>
      ),
      action: () => {
        history.push("/admin/centralizedAdmission/studentCharges");
      },
    },
    otherChargesPermissions && {
      heading: "Apply Centralized Other Charges",
      subHeading:
        "Counselors can apply additional charges for students from other branches.",
      icon: (
        <div style={commonIconStyles}>
          <DocumentIcon />
        </div>
      ),
      action: () => {
        history.push("/admin/centralizedAdmission/studentOtherCharges");
      },
    },
    paymentCollectionPermissions && {
      heading: "Centralized Payment Collection",
      subHeading:
        "Counselors can collect payments digitally for students from other branches.",
      icon: (
        <div style={commonIconStyles}>
          <DocumentIcon />
        </div>
      ),
      action: () => {
        history.push("/admin/centralizedAdmission/paymentCollection");
      },
    },
    manageReceiptsPermissions && {
      heading: "Manage Centralized Receipts",
      subHeading:
        "Counselors can print receipts or resend payment notifications for other branches.",
      icon: (
        <div style={commonIconStyles}>
          <DocumentIcon />
        </div>
      ),
      action: () => {
        history.push("/admin/centralizedAdmission/manageReceipts");
      },
    },
    dcrPermissions && {
      heading: "Centralized DCR",
      subHeading:
        "Counselors can view the Daily Collection Report (DCR) for students from other branches.",
      icon: (
        <div style={commonIconStyles}>
          <DocumentIcon />
        </div>
      ),
      action: () => {
        setIsOpenReportDialog(true);
      },
    },
  ];
  return (
    <>
      <div className={`screen-cards-container`}>
        {getScreenCards(cards?.filter((card) => card))}
      </div>

      {isOpenReportDialog && (
        <DownloadReports
          open={isOpenReportDialog}
          setOpen={setIsOpenReportDialog}
          isCentralizedFlow={true}
          userId={getCookie("userId")}
        />
      )}
    </>
  );
};

export default CentralizedAdmissionCards;
